export const partners = [
    { fullName: 'Felix Sprick', title: 'Geschäftsführer' },
    { fullName: 'Moritz Tränkner-Tuborgh', title: 'Partner' },
    { fullName: 'Djavad Hedayati', title: 'Partner' },
    { fullName: 'Christoph Gerdes', title: 'Partner' },
];
